import { Link } from "react-router-dom";
import { getPlanDefinition } from "../../config/plans";
import { PRICING_PAGE_ENABLED } from "../../config/featureFlags";
import "../../App.css";

export default function AccountPlanSection({ access }) {
  const tier = access?.tier ?? "free";
  const role = access?.role;
  const isAdminOrOwner = role === "admin" || role === "owner";

  return (
    <div className="account-card account-plan-card">
      <h3 className="account-card-title">Plan</h3>
      <div className="account-badges">
        <span className={`status-pill status-pill--${tier}`}>{getPlanDefinition(tier).name}</span>
        {role && role !== "user" && (
          <span className="status-pill status-pill--admin">{role.charAt(0).toUpperCase() + role.slice(1)}</span>
        )}
      </div>
      {PRICING_PAGE_ENABLED || isAdminOrOwner ? (
        <Link className="account-inline-link" to="/pricing">View Plans ›</Link>
      ) : (
        <p className="account-plan-note">Plan upgrades coming soon.</p>
      )}
    </div>
  );
}
